import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Observable } from 'rxjs';

import { MenuHeaderService } from './core/services/menu-header.service';
import { ResizeAppService } from './core/services/resize-application.service';
import { Menu } from './shared/models/menu.model';
import m from '../assets/data/menu.json';
import { FooterModel } from './shared/models/footer.model';
import data from 'src/assets/data/links-footer.json';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'mens';
  menu: Menu[] = [];
  alert$: Observable<string> | undefined;
  logo: string;
  closeButton: string;
  linksB4a: FooterModel[];
  linksBrand: FooterModel[];
  logoFooter: string;

  constructor(
    private _resizeAppService: ResizeAppService,
    private _menuHeaderService: MenuHeaderService,
    private gtmService: GoogleTagManagerService,
    private router: Router
    
  ) {}

  ngOnInit(): void {
    this.linksB4a = data.b4a;
    this.linksBrand = data.mens;
    this.logoFooter = 'assets/img/logo-white.svg';
    this.menu = m.menu;
    this.logo = 'assets/img/logo.svg';
    this.closeButton = 'assets/img/svg/close.svg';
    this.onResize();
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page_view',
          pageUrl: event.url
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
    // this._alertDialogService.showAlert('Frete grátis acima de R$ 250,00');
    // this.alert$ = this._alertDialogService.alert$;
  }

  // close() {
  //   this._alertDialogService.closeAlert();
  // }

  private onResize() {
    this._resizeAppService.onResize().subscribe(() => {
      this._menuHeaderService.close();
    });
  }
}
